import * as Utils from './utils';

export default modal => {
	const buttons = document.querySelectorAll('[aria-controls="' + modal.id + '"]:not(.init-modal)');
	const twice = modal;
	const links = twice.querySelectorAll('a');
	const box = modal.querySelector('.box');
	const actions = modal.querySelector('.actions');
	
	modal.addEventListener('click', (e) => {

		let target = e.target;

		do {
		    if (target == box || target == actions) {
		        return;
		    }

		    target = target.parentNode;

		} while (target);

		toggle(modal);
	})

	for (const button of buttons) {
		button.classList.add('init-modal');
	    button.addEventListener('click', (e) => {
	    	e.preventDefault();
	    	toggle(modal, button);
	    });
	}

	Utils.trapFocus(modal);

	document.addEventListener('keyup', (e) => {
	    if (e.key == "Escape") {
	    	desactive(modal)
	    }
	});

};

export function update() {
	const buttons = document.querySelectorAll('.js-modal-btn[aria-controls]:not(.init-modal)');

	for (const button of buttons) {
		button.classList.add('init-modal');

		const modal_id = button.getAttribute('aria-controls');
		const modal = document.querySelector(`#${modal_id}`);

		if (modal) {
			
		    button.addEventListener('click', (e) => {
		    	e.preventDefault();
		    	toggle(modal, button)
		    });
		}
	}
}

export function toggle(el = modal) {

	const active_el = document.querySelector('.modal.active');
	var store = true;

	if (active_el && active_el !== el) {
		desactive(active_el, false);
		store = false;
	}

	if (el.classList.contains('active')) {
		desactive(el);
		document.body.classList.remove('modal-displayed');
		return;
	}

	active(el, store);
}

export function active(el = modal, store = true) {
	setTimeout(() => {
		document.body.classList.add('modal-displayed');
	}, 500)


	if (!el.classList.contains('active')) {
		Utils.disableScroll();
		
		if (store) {
			Utils.historySave(window.location.href, document.title);
		}

		el.classList.add('displayed');
		setTimeout(() => {
			el.classList.add('active');
		}, 10);
	}

	if (!window.last_active) {
		window.last_active = document.activeElement;
	}

	const close = el.querySelector('.close');
	if (close) {
		close.focus();
	}

	el.setAttribute('aria-modal', 'true');

	const box = el.querySelector('.box');
	if (box) {
		box.scrollTo(0, 0);
	}

	if (el.hasAttribute('data-url')) {
		Utils.historySet(window.location.href, el.getAttribute('data-url'), el.getAttribute('data-title'));
	}

	// Utils.historySave(window.location.href, document.title);
	window.modal_active = el;

	// loop_focus(el);
}

export function desactive(el = modal, restore = true) {

	Utils.enableScroll();

	el.classList.remove('active');
	setTimeout(() => {
		el.classList.remove('displayed');
	}, 500);

	window.modal_active = false;

	if (window.on_modal_close_url && restore) {
		Utils.historyRestore();
	}

	if (window.last_active) {
		window.last_active.focus();
		window.last_active = false;
	}

	el.setAttribute('aria-modal', 'false');
}

export function is_active(el = modal) {
	return el.classList.contains('active');
}